// src/plugins/fontawesome.js
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faHome, faTasks, faShareSquare, faEnvelope, faGear, faPencil } from '@fortawesome/free-solid-svg-icons';
import { faBars } from '@fortawesome/free-solid-svg-icons'; // Példa, ha van ilyen ikon, különben másikat használj

library.add(faHome, faTasks, faShareSquare, faEnvelope, faGear, faPencil, faBars);

export { FontAwesomeIcon };
